<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img alt="login" class="mx-auto" src="@/assets/images/pages/login.png">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div v-if="login_error != ''" class="mb-5 bg-danger text-white error-container">
                  {{ login_error }}
                </div>

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome to Cockpit, please login to your account.</p>
                </div>


                <div>
                  <vs-input
                      v-model="email"
                      v-validate="'required'"
                      class="w-full"
                      icon="icon icon-user"
                      icon-no-border
                      icon-pack="feather"
                      label-placeholder="Email"
                      name="email"/>

                      <span class="text-danger">{{ errors.first('email') }}</span>

                  <vs-input
                      v-model="password"
                      v-validate="'required'"
                      class="w-full mt-6"
                      icon="icon icon-lock"
                      icon-no-border
                      icon-pack="feather"
                      label-placeholder="Password"
                      name="password"
                      type="password" />

                      <span class="text-danger">{{ errors.first('password') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                  </div>
                  <vs-button @click="attempt">Login</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{

  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      login_error: '',
    }
  },
  methods:{
    attempt(){

      this.login_error = ''
      this.$validator.validate().then(valid => {

        if (valid) {
          const params = new URLSearchParams();
          params.append('email', this.email );
          params.append('password', this.password );

          this.$http.post('/api/auth/login' , params)
            .then( res => {
                if( res.data.is_admin ){
                  this.$store.dispatch('do_login' , res.data)
                  setTimeout( () => {
                    this.$router.push('/dashboard')
                  }, 1000)
                }else{
                  this.login_error = 'You are not authorized to login here'
                }
            })
            .catch( err => {
              try {
              this.login_error = err.response.data.message
              } catch (error) {}
            })
        }

      });

    }
  }
}
</script>

<style lang="scss" scoped>

.error-container{
  font-size: 16px;
  padding-left: 10px;
}

</style>
